import { Box, styled } from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const styles = {
  buttons: {
    backgroundColor: "#27B6CB",
    color: "black",
    padding: "10px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  trialEndWarningModalButtonsContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
  } as const,
};

export const TrialEndWarningModalContainer = styled(Box)(({ theme }) => ({
  textAlign: "center",
  backgroundColor: APP_BACKGROUND_COLOR,
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  border: "2px solid #000",
  [theme.breakpoints.down("md")]: {
    width: "90%",
  },
}));

export const sendInviteModalStyles = {
  button: {
    backgroundColor: APP_COLOR,
    color: "black",
    height: "50px",
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  AddEmailContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  sendInviteButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  } as const,
  emailContainer: {
    display: "flex",
    alignContent: "center",
    margin: "8px",
    justifyContent: "space-between",
  },
};

export const addTrackFileModalStyles = {
  bpmInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
  } as const,
  collaboratorAddButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  collaboratorContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  horizontalDiv: {
    width: "100%",
    height: 2,
    backgroundColor: TEXT_COLOR,
    marginBottom: 10,
  } as const,
  emailInviteContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  emailInviteAddButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
};

export const addVersionModalStyles = {
  linearProgressContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  addingVersionSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  },
};

export const batchTrackAddModalStyles = {
  files: {
    height: 155,
    borderStyle: "dashed",
    borderWidth: "2px",
  } as const,
  fileNameContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  } as const,
  fileMainContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
  } as const,
};

export const collaboratorsModalStyles = {
  modalFooter: {
    display: "flex",
    backgroundColor: APP_BACKGROUND_COLOR,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  } as const,
  userNameLabelContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  addCollaboratorButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  confirmButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    height: 50,
    marginBottom: 1,
    width: "100%",
    fontFamily: FONT_FAMILY,
    fontSize: 18,
    fontWeight: "bold",
  } as const,
  inviteCollaboratorContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  inviteCollaboratorMainContainer: {
    width: "100%",
    height: 2,
    backgroundColor: "white",
    marginBottom: 10,
  } as const,
};

export const modalContainerStyles = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export const publishPermissionModalStyles = {
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "30px",
  } as const,
  button: {
    backgroundColor: "#28C0D5",
    color: "black",
    "&:hover": {
      backgroundColor: "#515D6A",
    },
  } as const,
};

export const userStatusModalStyles = {
  headingContainer: {
    textAlign: "center",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    paddingY: 1,
  } as const,
  heading: {
    fontWeight: "bold",
    marginTop: "10px",
    fontFamily: FONT_FAMILY,
  } as const,
  modalBodyContainer: {
    textAlign: "center",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
  } as const,
  loginSignUpButton: {
    paddingY: 1,
    paddingX: 2,
    fontFamily: FONT_FAMILY,
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
  } as const,
};

export const trackAddModalStyles = {
  albumInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
  } as const,
  genreLabel: {
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
  } as const,
  bpmLoadingContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  userNameSelectFieldContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  addUserNameButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  uploadingSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  } as const,
  email: {
    fontFamily: FONT_FAMILY,
    flexGrow: 1,
  } as const,
  inviteEmailButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  inviteEmailContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  inviteEmailMainContainer: {
    dth: "100%",
    height: 2,
    backgroundColor: "white",
    marginBottom: 10,
  } as const,
};

export const createFolderStyles = {
  container: {
    backgroundColor: APP_BACKGROUND_COLOR,
    padding: "10px",
    width: "400px",
  } as const,
};

export const FileTrackLinkingModalStyles = {
  addButton: {
    backgroundColor: APP_COLOR,
    color: "black",
    marginTop: "15px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  },
};
